import React, { FC, useState } from 'react'
import { Box, IconButton, Typography, Collapse, Stack } from '@mui/material'
import {
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from '@mui/icons-material'
import { colorTokens } from '@/apps/legacy/shared/styles/colorTokens'

interface CollapsibleCardProps {
  title: string
  children: React.ReactNode
  defaultExpanded?: boolean
  noPadding?: boolean
}

export const CollapsibleCard: FC<CollapsibleCardProps> = ({
  title,
  children,
  defaultExpanded = true,
  noPadding = false,
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded)

  const handleToggle = () => {
    setExpanded(!expanded)
  }

  return (
    <Box>
      {/* Toggle Header */}
      <Box
        onClick={handleToggle}
        sx={[
          {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            cursor: 'pointer',
            py: 1,
            px: 2,
            transition: 'all 0.3s ease',
          },
          expanded
            ? {
                backgroundColor: 'transparent',
              }
            : {
                backgroundColor: colorTokens.grey[100],
              },
          expanded
            ? {
                borderRadius: 0,
              }
            : {
                borderRadius: 2,
              },
          expanded
            ? {
                '&:hover': {
                  backgroundColor: 'transparent',
                },
              }
            : {
                '&:hover': {
                  backgroundColor: colorTokens.grey[200],
                },
              },
        ]}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <IconButton
            size="small"
            sx={{
              p: 0,
              color: colorTokens.text.secondary,
            }}
          >
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
          <Typography
            variant="subtitle2"
            sx={{
              color: colorTokens.grey[700],
            }}
          >
            {title}
          </Typography>
        </Stack>
      </Box>
      {/* Content */}
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Box
          sx={[
            {
              backgroundColor: colorTokens.background.paper,
              borderRadius: 2,
              border: `1px solid ${colorTokens.border.light}`,
              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            },
            noPadding
              ? {
                  p: 0,
                }
              : {
                  p: 3,
                },
          ]}
        >
          {children}
        </Box>
      </Collapse>
    </Box>
  )
}
